window.addEventListener('resize', function() {
  if (window.innerWidth <= 750) {
    
    const mediaElement = document.querySelector('.custome-product-info');
    const targetElement = document.querySelector('.product-grid__item.product-grid__item--content');

    if (mediaElement && targetElement) {

      targetElement.parentNode.insertBefore(mediaElement, targetElement.nextSibling);
    }
  }
});


  if (window.innerWidth <= 750) {
    
    const mediaElement = document.querySelector('.custome-product-info');
    const targetElement = document.querySelector('.product-grid__item.product-grid__item--content');

    if (mediaElement && targetElement) {

      targetElement.parentNode.insertBefore(mediaElement, targetElement.nextSibling);
    }
  }
